{
  "contacts": {
    "all_contacts": "Tous les contacts",
    "all_employees": "Tous les employés",
    "company_type": "Type de société",
    "relationship_partner": "Partenaire relationnel",
    "company_hierarchy": "Hiérarchie de l'entreprise",
    "known_by": "Connu par",
    "consent_status": "Statut de consentement",
    "key_activity": "Activité clé",
    "results": "Résultats",
    "add_new_contact": {
      "continue": "Continuer",
      "add_new_contact": "Ajouter un nouveau contact",
      "success": "Vous avez créé avec succès un nouveau contact",
      "first_step_header": "Ajouter un nouveau contact au personne",
      "first_step_header_description": "Ajoutez un nouveau courriel professionnel ou personnel à la personne et nous créons un nouveau contact basé sur celui-ci."
    }
  },
  "companies": {
    "all_companies": "Toutes les sociétés"
  },
  "key_activity": {
    "slide": {
      "aria_label": "diapositive d'activité clé",
      "contacts_involved": "Contacts Impliqués",
      "staff_involved": "Personnel Impliqué",
      "note": "Note",
      "comments": "Commentaires"
    },
    "performance": {
      "current": "Actuel",
      "best": "Meilleur",
      "consecutive": "Consécutif",
      "longest": "Plus Long",
      "weeks": "Semaines",
      "current_tooltip": "Vous avez enregistré {{count}} activités clés ce mois-ci",
      "best_tooltip": "Votre record personnel : {{count}} activités clés en un mois",
      "consecutive_tooltip": "Vous avez enregistré des activités clés hebdomadaires pendant {{count}} semaines",
      "longest_tooltip": "Votre plus longue série : {{count}} semaines"
    },
    "firm_wide": {
      "title": "Entreprise Entière",
      "this_month": "Ce Mois-ci",
      "tooltip": "Total des activités clés dans l'entreprise ce mois-ci"
    },
    "actions": {
      "update_aria_label": "modifier l'activité clé",
      "update_title": "modifier l'activité clé",
      "remove_aria_label": "supprimer l'activité clé",
      "remove_title": "supprimer l'activité clé",
      "log_new_activity": "Enregistrer une nouvelle activité"
    },
    "grid": {
      "loading_aria_label": "chargement des activités clés",
      "load_limit_message": "Il y a plus d'activités clés que celles affichées.",
      "show_less": "afficher moins",
      "show_more": "+{{count}} de plus"
    },
    "filters": {
      "select_employee": "Sélectionner un Employé",
      "select_month_year": "sélectionner le mois et l'année",
      "select_activity_category": "sélectionner la catégorie d'activité",
      "all_employees": "Tous",
      "basic": "Basique",
      "large": "Large"
    },
    "chart": {
      "business_development": "Activité de Développement Commercial",
      "lead_activity": "Activité de Prospection",
      "marketing_activity": "Activité Marketing"
    },
    "categories": {
      "business_development": "Développement Commercial",
      "lead": "Prospection",
      "marketing": "Marketing"
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Merci pour la mise à jour :)"
    },
    "contact_request_page": {
      "thank_you_message": "Merci d'avoir ajouté vos contacts. Vous pouvez maintenant fermer cette fenêtre.",
      "im_done": "J'ai terminé"
    },
    "header": {
      "instruction_text": "Veuillez sélectionner et ajouter vos contacts que vous souhaitez ajouter à la liste \"{{listName}}\". Une fois que vous avez ajouté vos contacts, cliquez sur \"J'ai terminé\"."
    },
    "my_contacts": {
      "my_contacts": "Mes Contacts",
      "company_type": "Type de société",
      "consent_status": "Statut de consentement",
      "no_contacts_message": "Il n'y a aucun contact à afficher ici"
    },
    "bulk_add": {
      "contact_list": "Liste de Contacts",
      "bulk_add_description": "Ajouter des contacts en lot à la liste",
      "adding_in_progress_message": "Le contact est en cours d'ajout. Veuillez actualiser la page pour voir la liste mise à jour.",
      "adding_in_progress_title": "Ajout de Contact en Cours",
      "add_selected": "Ajouter la Sélection"
    },
    "contacts_table": {
      "selected": "sélectionnés",
      "contact": "Contact",
      "company": "Société",
      "location": "Lieu",
      "last_interaction": "Dernière Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "diapositive de réunion",
      "add_key_activity": "Ajouter une activité clé",
      "contacts_involved": "Contacts impliqués",
      "staff_involved": "Personnel impliqué",
      "companies": "Entreprises"
    },
    "upcoming": {
      "cancelled": "[Annulé]",
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "no_meetings_coming_up": "Aucune réunion à venir"
    },
    "recent": {
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "create_task": "Créer une tâche",
      "create_note": "Créer une note",
      "no_recent_meetings": "Vous n'avez pas eu de réunion depuis un moment"
    },
    "calendar_view": {
      "all": "Tout",
      "select_all": "Tout sélectionner",
      "tasks": "Tâches",
      "external_meetings": "Réunions externes",
      "key_activities": "Activités clés",
      "task_tooltip": "tâche"
    },
    "contact_table": {
      "show_less": "Afficher moins",
      "show_more": "Afficher plus"
    },
    "key_activity": {
      "view_activity_details": "voir les détails de l'activité",
      "activity": "Activité",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Modifier l'activité",
      "remove": "Supprimer"
    }
  },
  "company_list": {
    "show_personal_info": "Afficher les informations personnelles",
    "close_personal_info": "Fermer les informations personnelles"
  },
  "reports": {
    "search_placeholder": "Rechercher un rapport",
    "loading": "Chargement des rapports",
    "loading_report": "Chargement du rapport",
    "empty_state": "Aucun rapport disponible",
    "browser_not_supported": "Votre navigateur ne prend pas en charge les iframes."
  }
}
